import { faDollar, faEur, faGbp } from '@fortawesome/free-solid-svg-icons';

export const _FIAT_PRICE_API = 'https://api.coingecko.com/api/v3/coins/';

export const _FIAT_API_NAME_CONVERSIONS = {
  'BNB': 'binancecoin',
  'MATIC': 'matic-network',
  'wDOGE': 'dogecoin',
};

export const _SUPPORTED_FIAT_CURRENCIES = [
  {},
  { symbol: "usd", icon: faDollar },
  { symbol: "eur", icon: faEur },
  { symbol: "gbp", icon: faGbp }
];
